import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await register(email, password, fullName);
    
    if (result.success) {
      toast.success('¡Cuenta creada exitosamente!');
      navigate('/dashboard');
    } else {
      toast.error(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#F5F5F0' }}>
      <div className="w-full max-w-md">
        <div className="bg-white border border-border shadow-sm rounded-sm p-8" data-testid="register-form">
          <Link to="/" className="block mb-8">
            <div className="flex flex-col items-center gap-3">
              <img src="/assets/logo.png" alt="contractcheck360" className="h-16 w-auto" />
              <span className="text-2xl brand-name" style={{ color: '#1A4D2E' }}>
                contractcheck360
              </span>
            </div>
          </Link>
          
          <h2 className="text-2xl font-semibold mb-2" style={{ fontFamily: 'Merriweather, serif' }}>
            Crear Cuenta
          </h2>
          <p className="text-base mb-6" style={{ color: '#64748B' }}>
            Comienza a analizar tus contratos hoy
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-2" style={{ color: '#0F172A' }}>
                Nombre Completo
              </label>
              <Input
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
                className="h-12 bg-white border border-input focus:border-primary focus:ring-1 focus:ring-primary rounded-sm transition-all"
                placeholder="Juan Pérez"
                data-testid="register-name-input"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2" style={{ color: '#0F172A' }}>
                Correo Electrónico
              </label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="h-12 bg-white border border-input focus:border-primary focus:ring-1 focus:ring-primary rounded-sm transition-all"
                placeholder="tu@email.com"
                data-testid="register-email-input"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2" style={{ color: '#0F172A' }}>
                Contraseña
              </label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
                className="h-12 bg-white border border-input focus:border-primary focus:ring-1 focus:ring-primary rounded-sm transition-all"
                placeholder="Mínimo 8 caracteres"
                data-testid="register-password-input"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-primary text-primary-foreground hover:bg-primary/90 h-11 rounded-sm font-medium"
              style={{ backgroundColor: '#1A4D2E' }}
              data-testid="register-submit-btn"
            >
              {loading ? 'Creando cuenta...' : 'Crear Cuenta'}
            </Button>
          </form>

          <p className="text-center text-sm mt-6" style={{ color: '#64748B' }}>
            ¿Ya tienes cuenta?{' '}
            <Link to="/login" className="font-medium hover:underline" style={{ color: '#1A4D2E' }}>
              Inicia sesión
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;